import Icon from '../components/Icon.vue'

Icon.register({
  'money-bill-alt': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M352 288c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-64c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h16v-55.4l-0.5 0.3c-1.1 0.7-3.1 1.3-4.4 1.3-2.4 0-5.3-1.6-6.7-3.6l-8.9-13.3c-0.7-1.1-1.3-3.1-1.3-4.4 0-2.4 1.6-5.3 3.6-6.7l15.3-10.2c3.9-2.6 8.6-4 13.3-4h13.6c4.4 0 8 3.6 8 8v88h16zM608 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32h-576c-17.7 0-32-14.3-32-32v-320c0-17.7 14.3-32 32-32h576zM48 400h64c0-35.3-28.7-64-64-64v64zM48 176c35.3 0 64-28.7 64-64h-64v64zM320 368c53 0 96-50.1 96-112 0-61.9-43-112-96-112s-96 50.1-96 112c0 61.8 43 112 96 112zM592 400v-64c-35.3 0-64 28.7-64 64h64zM592 176v-64h-64c0 35.3 28.7 64 64 64z'
      }
    ]
  }
})
